import { ErrorHandler } from '@angular/core';
import { NGXLogger } from 'ngx-logger';

export class LogRocketErrorHandler implements ErrorHandler {
  constructor(private ngxLogger: NGXLogger) {}
  public handleError(error) {
    this.ngxLogger.error(error);
  }
}
